import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { all as bboxStrategy } from 'ol/loadingstrategy'
import * as turf from '@turf/turf'
import { Vector as VectorLayer } from 'ol/layer'
import { Fill, Stroke, Style } from 'ol/style'
import {setupMarkers} from '../helpers';

const testLayer = () => {
  const bbox = [59.6122104, 59.6128035, 16.5404633, 16.5421712]
  const polygon = turf.bboxPolygon([bbox[2], bbox[0], bbox[3], bbox[1]])

  const source = new VectorSource({
    format: new GeoJSON({
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857'
    }),
    projection: 'EPSG:3857',
    features: setupMarkers(polygon),
    strategy: bboxStrategy
  })

  const layer = new VectorLayer({
    className: 'testLayer',
    zIndex: 1,
    source,
    style: function (feature, extent) {
      return new Style({
        stroke: new Stroke({
          color: '#ffffff',
          width: 3
        }),
        fill: new Fill({
          color: 'rgb(221,137,1, 0.5)'
        })
      })
    }
  })

  return layer
}

export default testLayer
